const INTL_LOCALE_BY_LANGUAGE: Record<string, string> = {
    nb: "nb-NO",
    no: "nb-NO",
    sv: "sv-SE",
    da: "da-DK",
    en: "en-GB",
};

const DEFAULT_INTL_LOCALE = "nb-NO";

/** Maps an i18next resolved language to its Intl locale for number
 *  formatting. Falls back to nb-NO for an unmapped or missing language. */
export const intlLocaleForLanguage = (language: string | undefined): string =>
    INTL_LOCALE_BY_LANGUAGE[(language ?? "nb").split("-")[0]] ?? DEFAULT_INTL_LOCALE;
